export const API_URL = 'https://ecvod4fh44.execute-api.eu-central-1.amazonaws.com/export-studio-production-api-gateway-stage/api/v1/';